import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { toast } from '@/components/ui/toast';
import { useAuthStore } from '@/store/auth.store';
import { useVerifyLogin } from './useVerifyLogin';
import { ROUTES } from '@/constants/route.constant';
import { LOGIN_CONSTANTS } from '../constants/login.constants';

const useGetTokenAndRedirectToDashboard = () => {
  const { setAuthToken, logout } = useAuthStore();
  const navigate = useNavigate();

  const { mutate: handleVerifyLogin } = useVerifyLogin();

  const params = new URLSearchParams(window.location.search);
  const code = params.get(LOGIN_CONSTANTS.CODE) ?? '';

  useEffect(() => {
    if (!code) return;

    handleVerifyLogin(
      { code },
      {
        onSuccess: (data) => {
          if (data?.data?.token) {
            setAuthToken(data.data?.token);
            setTimeout(() => {
              navigate(ROUTES.DASHBOARD.TIMESHEET, { replace: true });
            }, 50);
          }
        },
        onError: () => {
          logout();
          toast.error('Login verification failed');
          setTimeout(() => {
            navigate(ROUTES.AUTH.LOGIN, { replace: true });
          }, 50);
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);
};

export default useGetTokenAndRedirectToDashboard;
